<template>
	<div class="slb-list-container init">
		<div class="cps-page-top">
			<div class="jc-page-header">
				<el-page-header :title="$t('slb.text.cert')" />
				<div class="jc-box-action">
					<a v-bind:href="Config.SLB_HELP_URL" target="_blank">
						{{$t('slb.text.slbHelpDoc')}}
					</a>
				</div>
			</div>

			<div class="jc-page-content">
				<div class="jc-container-table">
					<div class="jc-container-table-actionBar flex-display">
						<!--刷新和切换地域-->
						<el-form class="jc-table-actionBar-item" :inline="true">
							<!--刷新-->
							<el-form-item>
								<el-button icon="jc-icon-refresh-line" class="jc-button-icon"
									@click="updateList('refresh')">
								</el-button>
							</el-form-item>
							<!--切换地域-->
							<el-form-item>
								<el-radio-group v-model="region" @change="regionChange">
									<el-radio-button v-for="(area, index) in region_map"
										:key="index"
										:label="area.region">
										{{ area.regionName }}
									</el-radio-button>
								</el-radio-group>
							</el-form-item>
							<!-- 创建证书 -->
							<el-form-item>
								<el-tooltip :content="$t('slb.sentence.moreThan100')"
											placement="bottom" effect="dark"
											:disabled="certCount < 100">
									<label>
										<el-button type="primary" @click="showCreateCertDialog()"
													:disabled="certCount >= 100">
											{{ $t('slb.text.createCert')}}
										</el-button>
									</label>
								</el-tooltip>
							</el-form-item>
						</el-form>
						<el-form class="jc-box-table-search" :inline="true" @submit.native.prevent>
							<!--搜索-->
							<el-form-item>
								<el-input v-entire-placeholder style="height:30px;width:412px"
									@keyup.enter.native="updateList('refresh')"
									:placeholder="currentPlaceholder"
									v-model="currentSearchValue">
									<el-button slot="append" icon="jc-icon-search" class="search-icon"
										@click="updateList('refresh')">
									</el-button>
								</el-input>
							</el-form-item>
						</el-form>
						
					</div>
					<!--列表数据-->
					<el-table :data="tableData" style="width: 100%"
						class="jc-list-table jc-table-header-cell" v-loading="refreshLoading"
						ref="listTable" :empty-text="$t('speechCraft.listEmptyText')">
						<!--名称-->
						<el-table-column :label="$t('slb.text.name')" min-width="250" key="id">
							<template slot-scope="scope">
								<el-tooltip class="item" effect="dark" :content="scope.row.name"
									placement="bottom">
									<a href="javascript:void(0)"
										 @click="jumpToDetail(scope.row)">
										{{scope.row.name}}
									</a>
								</el-tooltip>
							</template>
						</el-table-column>
						<!--监听器数量-->
						<el-table-column min-width="250" key="listenerCount" prop="listenerCount"
							:label="$t('slb.text.associatedMonitoring')">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="jumpToDetail(scope.row)">
									{{scope.row.listenerCount | maybeEmpty}}
								</a>
							</template>
						</el-table-column>
						<!--操作-->
						<el-table-column key="operation" min-width="250"
							:label="$t('listPage.tableLabel.operation')">
							<template slot-scope="scope">
								<!--删除-->
								<el-tooltip placement="bottom"
									:content="$t('slb.sentence.cannotDelete')"
									:disabled="scope.row.listenerCount<=0">
									<div slot="content">{{$t('slb.sentence.cannotDelete')}}</div>
										<label>
											<el-button
												type="text"
												href="javascript:void(0)"
												:disabled="scope.row.listenerCount>0"
												@click="showDeleteCertDialog(scope.row)">
												{{ $t('operations.delete.name') }}
											</el-button>
										</label>
								</el-tooltip>	
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<!--删除证书-->
			<delete-cert 
			:visible.sync="deleteCertVisible"
			@refresh="updateList('refresh')"
			:rowInfo="rowInfo"
			:pageSource="'list'">
			</delete-cert>
			<!-- 创建证书 -->
			<create-cert
			:visible.sync="createCertVisible"
			@refresh="updateList('refresh')"
			:region="region">
			</create-cert>
		</div>
		<div ref="footer" class="cps-page-footer block jc-container-table-actionBar" v-if="total > 0">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
			NetworkTypeConstant,
		} from '@/common/Constants';
	import deleteCert from '@/components/slb/deleteCert';
	import createCert from '@/components/slb/createCert';
	const initPage = 1;
	export default {
		components: {
			deleteCert,
			createCert,
		},
		name: 'CertList',
		data() {
			return {
				currentPage: initPage,
				region_map: [],
				region: null,
				tableData: [],
				refreshLoading: false,
				regionMap: {},
				// 当前搜索input框值
				currentSearchValue: '',
				// 当前搜索条件对应placeholder
				currentPlaceholder: this.$t('list.searchPlaceholder.name'),
				pageSize: 20,
				pageSizes: [20, 50, 100], // 可选每页展示多少条
				total: 0,
				// 自定义列表类型
				type: 'slbList',
				//证书数量
				certCount: 0,
				// 当前行数据
				rowInfo: {},
				// 删除证书
				deleteCertVisible: false,
				//创建证书
				createCertVisible: false,
			};
		},
		mounted() {
			this.getRegion();
		},
		watch: {
			region(newValue) {
				if(newValue) {
					this.regionChange()
				}
			},
		},
		computed: {},
		methods: {
			getRegion() {
				const params = {
					networkType: NetworkTypeConstant.VPC
				};
				Ajax.get('api/cps/getRegions', params).then((res) => {
					const target = this;
					if (res.data) {
						res.data.regions.forEach((region, index) => {
							if (index === 0) {
								if (target.$route.query && target.$route.query.region) {
									target.region = target.$route.query.region;
								} else {
									target.region = region.region;
								}
							}
							const tempFormat = {};
							tempFormat.region = region.region;
							tempFormat.regionName = region.regionName;
							target.region_map.push(tempFormat);
						});
					}
				}) 
				.catch()
				.finally(() => {
					this.loading = false
				});
			},
			/**
			 **@disc: 确定搜索和导出参数
			 */
			getParamsForSearchAndExport(params){
				// 搜索部分添加参数
				if (this.currentSearchValue !== '') {
					params.name = this.currentSearchValue;
				}
			},
			/**
			 **@disc: 获取负载均衡证书数据
			 **@params: none
			 */
			getSlbCertListData() {
				// 基础参数
				const param = {
					region: this.region,
					pageNumber: this.currentPage,
					pageSize: this.pageSize,
				};
				this.getParamsForSearchAndExport(param)
				this.refreshLoading = true;
				Ajax.get('/api/cps/queryCertificatePage', param)
				.then((res) => {
					const list = res.data.certs;
					this.tableData = list;
					this.total = res.data.totalCount;
					this.certCount = res.data.totalCount;
				})
				.catch(async (err) => {
					const {response} = err.data;
					try {
						const json = await response.json();
						//target.$message.error(json.errmsg);
						this.tableData = [];
						this.total = 0;
						this.certCount = 0;
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
					this.refreshLoading = false;
				})
			},
			updateList(type) {
				if (type === 'refresh') {
					this.refreshLoading = true;
					this.currentPage = 1;
				}
				this.getSlbCertListData();
			},
			// 选择地区
			regionChange () {
				this.$refs.listTable.clearFilter();
				this.currentSearchValue = '';
				this.currentPage = initPage;
				this.updateList('refresh');
			},
			jumpToDetail(row) {
				this.$router.push({
					path: `/lb/cert/detail`,
					query: {
						region: this.region,
						certId: row.certId,
					}
				});
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.updateList('refresh');
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.updateList();
			},
			//创建证书
			showCreateCertDialog(){
				this.createCertVisible = true;
			},
			//删除证书
			showDeleteCertDialog(rowInfo){
				this.rowInfo = rowInfo
				this.deleteCertVisible = true;
			}
		}
	};
</script>


<style lang="scss">
	@import '~@/assets/scss/listComon';
	@import '~@/assets/scss/paginationCommon';
	@import '~@/assets/scss/sliderCommon';
</style>



// WEBPACK FOOTER //
// src/views/slb/cert/list/List.vue